export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", event, params);
  }
};

export const injectAnalytics = ({ ga4, google_verification, bing_verification } = {}) => {
  if (google_verification && !document.querySelector('meta[name="google-site-verification"]')) {
    const m = document.createElement("meta");
    m.name = "google-site-verification";
    m.content = google_verification;
    document.head.appendChild(m);
  }
  if (bing_verification && !document.querySelector('meta[name="msvalidate.01"]')) {
    const m = document.createElement("meta");
    m.name = "msvalidate.01";
    m.content = bing_verification;
    document.head.appendChild(m);
  }
  if (ga4 && !window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    const loadGa = () => {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
      document.head.appendChild(s);
      window.gtag("js", new Date());
      window.gtag("config", ga4);
    };
    // Fora do caminho crítico: carrega o GA só depois do load completo da página
    if (document.readyState === "complete") {
      setTimeout(loadGa, 1500);
    } else {
      window.addEventListener("load", () => setTimeout(loadGa, 1500), { once: true });
    }
  }
};
